import React from 'react';
import Typography from 'housecall-ui/dist/DesignSystem/DataDisplay/Typography/Typography';
import Button from 'housecall-ui/dist/DesignSystem/Inputs/Buttons/Button';
import Grid from 'housecall-ui/dist/DesignSystem/Layout/Grid/Grid';
import FundboxAppIcon from 'housecall-ui/dist/IconsAndImages/AppIcons/FundboxAppIcon';

import { businessFinancingPaths } from 'components/BusinessFinancing/routes';

const FundboxStrategy = {
  previewInfo: {
    name: 'Fundbox',
    newTab: true,
    iconSvg: <FundboxAppIcon size="xlarge" />,
  },
  headerInfo: {
    name: 'Fundbox',
    category: 'Business lending',
    details:
      'Fundbox provides revolving lines of credit for small businesses that are super easy to use. Our goal is to simplify and improve the way that small businesses pay and are paid. Choose an amount to draw and see it in your bank account the next day.',
    iconSvg: <FundboxAppIcon size="xlarge" />,
  },
  sellingPoints: {
    headline: 'How does Fundbox work?',
    bottomDescription: (
      <div>
        <div>
          <Typography variant="subtitle1">1. Get a credit decision in under 3 minutes</Typography>
          <p>
            Connect your accounting software or business bank account to give us insight into your business. Choose
            whichever represents your business performance best.
          </p>
        </div>

        <div>
          <Typography variant="subtitle1">2. Funds right away</Typography>
          <p>
            If approved, draw funds anytime. Funds transfer as soon as the next business day. Only pay when you draw.{' '}
          </p>
        </div>

        <div>
          <Typography variant="subtitle1">3. Pay it back over time </Typography>
          <p>
            Repay your draw plus a weekly fee over 12 or 24 weeks. Each week the amount you repaid (minus the fees)
            becomes available again. Repay early and we&apos;ll waive all the remaining fees.{' '}
          </p>
        </div>
      </div>
    ),
  },
  planAvailability: {
    title: 'Housecall Pro Plan',
    description: (
      <Grid container spacing={8}>
        <Grid item xs={4}>
          <Typography align="left" variant="body1">
            Basic plan
          </Typography>
        </Grid>
        <Grid item xs={8}>
          <Typography align="right" variant="body1">
            Available
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="left" variant="body1">
            Essentials plan
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="right" variant="body1">
            Available
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="left" variant="body1">
            MAX plan
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="right" variant="body1">
            Available
          </Typography>
        </Grid>
      </Grid>
    ),
  },
  price: {
    title: 'Partner Pricing',
    appActionButton: (
      <Button
        variant="contained"
        color="primary"
        style={{ color: '#ffffff', width: '100%' }}
        onClick={() => {
          window.location = businessFinancingPaths.fundbox;
        }}
      >
        Apply for funding
      </Button>
    ),
    description: (
      <Grid container spacing={8}>
        <Grid item>
          <Typography align="left" variant="body1">
            <a href="https://fundbox.com/pricing/" target="_blank" rel="noreferrer">
              https://fundbox.com/pricing/
            </a>
          </Typography>
        </Grid>
        <Grid item>
          <Typography align="center" color="textSecondary">
            Starting at 4.66%
          </Typography>
        </Grid>
      </Grid>
    ),
    hideToggle: true,
    showBetaButton: false,
  },
  supportContacts: [
    { type: 'Website', contact: 'www.fundbox.com' },
    { type: 'Phone', contact: '(855) 572-7707' },
    { type: 'Support', contact: <a href="mailto:support@fundbox.com">support@fundbox.com</a> },
    { type: 'Help center', contact: <a href="http://help.fundbox.com/">https://help.fundbox.com/</a> },
  ],
};

export default FundboxStrategy;
